import { createContext } from 'react';
import { SelectedLocation } from './types/selected-location';

export interface SelectedLocationContextProps {
  selectedLocation: SelectedLocation;
}

export const SelectedLocationContext = createContext<SelectedLocationContextProps>(null!);